import { Box } from '@mui/material'
import { usePlanningStore } from '@planning/AppProvider'
import { InitializationWrapper } from '@planning/components'
import { useMinimalsTheme } from '@tom-ui/ui'
import { PATHS, useAsyncFetch } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { useNavigate, useParams } from 'react-router'
import { ReleaseExpiredAssignmentAlert } from '../../Components/atoms/ReleaseExpiredAssignmentAlert'
import { NumericReleaseDetailsHeader } from '../../Components/organisms/NumericReleases/NumericReleaseDetailsHeader'
import { NumericReleaseDetailsTable } from '../../Components/organisms/NumericReleases/NumericReleaseDetailsTable'
import { NumericReleaseSummary } from '../../Components/organisms/NumericReleases/NumericReleaseSummary'
import { NumericReleaseDetailsViewStore } from '../../Stores/NumericReleaseDetailsViewStore'

export const NumericReleasesDetailsPage = observer(() => {
  const navigate = useNavigate()
  const theme = useMinimalsTheme()

  const {
    numericReleaseItemStore,
    orderItemStore,
    railVisitItemStore,
    vesselVisitItemStore,
    companyItemStore,
  } = usePlanningStore()

  const { numericReleaseId } = useParams()

  if (!Number(numericReleaseId) || Number(numericReleaseId) < 0) {
    navigate(PATHS.orders.numericReleases.url)
  }

  const id = Number(numericReleaseId)

  const releaseDetailsViewStore = useMemo(
    () =>
      new NumericReleaseDetailsViewStore(
        id,
        numericReleaseItemStore,
        orderItemStore,
        railVisitItemStore,
        vesselVisitItemStore,
        companyItemStore,
      ),
    [
      companyItemStore,
      id,
      numericReleaseItemStore,
      orderItemStore,
      railVisitItemStore,
      vesselVisitItemStore,
    ],
  )

  const { loading } = useAsyncFetch(async () => {
    await numericReleaseItemStore.fetchById(id)
  }, [id, numericReleaseItemStore])

  useAsyncFetch(async () => {
    await Promise.all([
      releaseDetailsViewStore.fetchOrders(),
      releaseDetailsViewStore.fetchVisits(),
      releaseDetailsViewStore.fetchTransportCompany(),
    ])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [releaseDetailsViewStore.numericRelease])

  if (!releaseDetailsViewStore.numericRelease) return <></>

  const numericRelease = releaseDetailsViewStore.numericRelease

  return (
    <InitializationWrapper isInitializing={loading}>
      <Box sx={{ height: '100%', bgcolor: theme.palette.grey[100] }}>
        <NumericReleaseDetailsHeader
          viewStore={releaseDetailsViewStore}
          numericRelease={releaseDetailsViewStore.numericRelease}
        />
        {numericRelease.isExpired && (
          <Box padding={theme.customSpacing.m} pb={0}>
            <ReleaseExpiredAssignmentAlert />
          </Box>
        )}
        <Box padding={theme.customSpacing.m}>
          <NumericReleaseSummary numericReleaseItem={numericRelease} />
          <NumericReleaseDetailsTable
            viewStore={releaseDetailsViewStore}
            numericRelease={numericRelease}
          />
        </Box>
      </Box>
    </InitializationWrapper>
  )
})
